import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import { faqs, site } from "@/mocks/content";
import HeroSection from "./components/HeroSection";
import CategoryStrip from "./components/CategoryStrip";
import FeedSection from "./components/FeedSection";
import TopicSection from "./components/TopicSection";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";

export default function Home() {
  useSeo({
    title: "网红吃瓜今日瓜_最新爆料速递 - 吃瓜日报",
    description:
      "吃瓜日报汇总网红吃瓜今日瓜与最新爆料，聊天记录、事件时间线、当事方回应一站整理，涵盖恋爱八卦、人设塌房、直播翻车、带货争议等热门瓜料，新鲜瓜料实时更新。",
    keywords: "网红吃瓜,今日瓜,最新爆料,新鲜瓜,新瓜速递,今日爆料",
    canonical: "https://jcspower.cn/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: site.name,
        url: "https://jcspower.cn/",
        description: site.description,
        potentialAction: {
          "@type": "SearchAction",
          target: "https://jcspower.cn/news?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: site.name,
        url: "https://jcspower.cn/",
        email: site.email,
        description: site.description,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <HeroSection />
      <CategoryStrip />
      <FeedSection />
      <TopicSection />
      <FaqSection />
      <BrandSection />
    </SiteLayout>
  );
}